import request from '@/services/request'

export default {
  getListing: {
    url: '/listing/getListing',
    method: 'post',
    desc: 'listing管理列表'
  },
  batchSubcrible: {
    url: '/listing/batchSubcrible',
    method: 'post',
    desc: '批量关注商品'
  },
  batchCancelSubcrible: {
    url: '/listing/batchCancelSubcrible',
    method: 'post',
    desc: '批量取消关注商品'
  },
  batchMatchGoods: {
    url: '/listing/batchMatchGoods',
    method: 'post',
    desc: '批量匹配运营负责人'
  },
  batchCancelMatchGoods: {
    url: '/listing/batchCancelMatchGoods',
    method: 'post',
    desc: '批量取消匹配运营负责人'
  },
  /**
   * 修改listing属性
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchListingModify: (data, options = {}) => {
    return request(
      {
        url: '/listing/modify',
        method: 'post',
        desc: '修改listing属性'
      },
      data,
      options
    )
  },
  fetchListingChargerList: (data, options = {}) => {
    return request(
      {
        url: '/listing/getChargerList',
        method: 'get',
        desc: '获取list运营负责人列表'
      },
      data,
      options
    )
  },
  fetchListingUploadLogList: (data, options = {}) => {
    return request(
      {
        url: '/listing/getUploadLog',
        method: 'post',
        desc: '获取listing操作日志列表'
      },
      data,
      options
    )
  },
  fetchListingGoodsBasicInfo: (data, options = {}) => {
    return request(
      {
        url: '/listing/getGoodsInfo',
        method: 'post',
        desc: '获取listing货物寄出信息'
      },
      data,
      options
    )
  },
}
